import { DrawableObject } from "./DrawableObject";
import { WorldObjectType, } from "../../api";
import { Sphere, Vector3 } from "three";
export class TilesetObject extends DrawableObject {
    constructor(object) {
        super(object);
        this.object = object;
    }
    get attributions() {
        return this.object.attributions;
    }
    get pointChannels() {
        var _a, _b;
        return (_b = (_a = this.skandMetadata) === null || _a === void 0 ? void 0 : _a.pointsExtraChannels) !== null && _b !== void 0 ? _b : {};
    }
    get maximumScreenSpaceError() {
        return this.object.maximumScreenSpaceError;
    }
    set maximumScreenSpaceError(v) {
        this.object.maximumScreenSpaceError = v;
    }
    get tileBudget() {
        return this.object.tileBudget;
    }
    set tileBudget(v) {
        this.object.tileBudget = v;
    }
    applyStyle(style) {
        this.object.applyStyle(style);
    }
    setClippingPlanes(planes) {
        this.object.setClippingPlanes(planes);
    }
    invalidateMaterials() {
        this.object.invalidateMaterials();
    }
    getBoundingVolume() {
        this.object.updateMatrix();
        const localTransform = this.object.tileset.root.extras.transform;
        const sphere = new Sphere(new Vector3(this.object.tileset.root.boundingVolume.sphere[0], this.object.tileset.root.boundingVolume.sphere[1], this.object.tileset.root.boundingVolume.sphere[2]), this.object.tileset.root.boundingVolume.sphere[3])
            .applyMatrix4(localTransform)
            .applyMatrix4(this.object.matrix);
        return [sphere.center.x, sphere.center.y, sphere.center.z, sphere.radius];
    }
    getEstimatedCenter(center) {
        var _a;
        this.object.updateMatrix();
        const localTransform = this.object.tileset.root.extras.transform;
        let result;
        const maybeMetadata = (_a = this.object.tileset.extensions) === null || _a === void 0 ? void 0 : _a.SKAND_tileset_metadata;
        if (maybeMetadata !== undefined) {
            const metadata = maybeMetadata;
            if (metadata.boundingBox !== undefined) {
                result = new Vector3(metadata.boundingBox[0], metadata.boundingBox[1], metadata.boundingBox[2])
                    .applyMatrix4(localTransform)
                    .applyMatrix4(this.object.matrix);
            }
        }
        if (result === undefined) {
            const sphere = this.object.tileset.root.boundingVolume.sphere;
            result = new Vector3(sphere[0], sphere[1], sphere[2])
                .applyMatrix4(localTransform)
                .applyMatrix4(this.object.matrix);
        }
        if (center !== undefined) {
            center.x = result.x;
            center.y = result.y;
            center.z = result.z;
            return center;
        }
        else {
            return result;
        }
    }
    get isTransparent() {
        return this.object.styledTransparent;
    }
    getObjectType() {
        return WorldObjectType.TilesetObject;
    }
    asStylableObject() {
        return this;
    }
    asTileset() {
        return this;
    }
    get skandMetadata() {
        var _a;
        const maybeMetadata = (_a = this.object.tileset.asset.extensions) === null || _a === void 0 ? void 0 : _a.SKAND_tileset_metadata;
        if (maybeMetadata !== undefined) {
            return maybeMetadata;
        }
        else {
            return undefined;
        }
    }
}
